<script lang="ts">
    import src from './svg/cancel_FILL0_wght400_GRAD0_opsz24.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    export let scale: number = 1;
</script>

<TemplateIcon {src} {scale} alt="Clear" on:click />
